import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import { ControlLabel } from 'react-bootstrap';
import ModalForm from 'components/ModalForm';
import styles from './styles.css';
import messages from './messages';


const ReturnTransferForm = ({ handleSubmit, show, onHide }) => (
  <ModalForm
    onHide={onHide}
    show={show}
    handleSubmit={handleSubmit}
    title={<FormattedMessage {...messages.returnTransfer} />}
    submitLabel={<FormattedMessage {...messages.submit} />}
  >
    <ControlLabel htmlFor="comment" className={styles.commentLabel}>
      <FormattedMessage {...messages.comment} />
      <Field
        name="comment"
        component="textarea"
        className="form-control"
      />
    </ControlLabel>
  </ModalForm>
);

ReturnTransferForm.propTypes = {
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({ form: 'ReturnTransfer', enableReinitialize: true })(ReturnTransferForm);




// WEBPACK FOOTER //
// ./src/components/ReturnTransferForm/index.js